/* Thème neutre 4.0 : recherche prédictive de l'en-tête (Predictive Search API, rendu par la section nt-predictive-search).
   - Produits, collections, articles, pages et suggestions de requête ; aperçu des prix ; état vide ; recherches récentes
     (stockées dans ce navigateur seulement, effaçables) ; aide quand le champ est trop court.
   - Clavier : flèches haut/bas, Début/Fin, Entrée, Échap, Tab. Rôles ARIA combobox / listbox / option.
   - Panneau posé sur <body> en position fixe sous le champ actif (jamais rogné par l'en-tête).
   - Requêtes annulées et mises en cache ; repli : le formulaire de recherche normal fonctionne toujours.
   Écouteurs délégués sur document, posés une seule fois. */
(function () {
  'use strict';
  if (window.__ntPs) return;
  window.__ntPs = true;

  var FORMS = '.search_form, .header_search_form, .search__form, form.search';
  var MIN = 2, DELAY = 170, RECENT_KEY = 'nt-recent-searches', MAX_RECENT = 5;
  var st = { input: null, form: null, panel: null, scroll: null, status: null, timer: null, ctrl: null, seq: 0, active: -1, cache: {}, lastQ: null, raf: 0, loadTimer: 0 };

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function closest(el, sel) { while (el && el.nodeType === 1) { if ((el.matches || el.msMatchesSelector).call(el, sel)) return el; el = el.parentNode; } return null; }
  function enabled() { return !!(window.Shopify && Shopify.theme_settings && Shopify.theme_settings.nt_predictive); }
  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function limit() {
    var n = parseInt(window.Shopify && Shopify.theme_settings && Shopify.theme_settings.search_items_to_display, 10);
    return Math.max(3, Math.min(10, isFinite(n) ? n : 6));
  }

  /* ---------- récents (local) ---------- */
  function getRecent() { try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }).slice(0, MAX_RECENT) : []; } catch (e) { return []; } }
  function setRecent(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT))); } catch (e) { /* stockage refusé : sans importance */ } }
  function addRecent(term) {
    term = String(term || '').trim();
    if (term.length < 2) return;
    var l = getRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    l.unshift(term);
    setRecent(l);
  }

  /* ---------- panneau ---------- */
  function ensurePanel() {
    if (st.panel && document.body.contains(st.panel)) return st.panel;
    var p = document.createElement('div');
    p.className = 'nt-ps';
    p.id = 'nt-ps-panel';
    p.hidden = true;
    p.innerHTML = '<div class="nt-ps__bar" aria-hidden="true"></div><div class="nt-ps__scroll" data-nt-ps-scroll></div><div class="nt-ps__status" role="status" aria-live="polite" data-nt-ps-status></div>';
    document.body.appendChild(p);
    st.panel = p; st.scroll = p.querySelector('[data-nt-ps-scroll]'); st.status = p.querySelector('[data-nt-ps-status]');
    /* garder le focus dans le champ quand on clique dans le panneau */
    p.addEventListener('mousedown', function (e) { e.preventDefault(); });
    p.addEventListener('click', function (e) {
      var clr = closest(e.target, '[data-nt-ps-clear]');
      if (clr) { setRecent([]); showIdle(); return; }
      var a = closest(e.target, 'a[role="option"]');
      if (a) {
        var t = a.getAttribute('data-nt-ps-query') || a.getAttribute('data-nt-ps-recent') || (st.input && st.input.value);
        if (a.hasAttribute('data-nt-ps-query') || a.hasAttribute('data-nt-ps-recent') || a.classList.contains('nt-ps__item--all')) addRecent(t);
      }
    });
    return p;
  }

  function place() {
    if (!st.input || !st.panel || st.panel.hidden) return;
    var host = st.form || st.input;
    var r = host.getBoundingClientRect();
    if (!r.width || !r.height) { close(); return; }
    var vv = window.visualViewport;
    var vpw = document.documentElement.clientWidth, vh = vv ? vv.height : window.innerHeight;
    var top = Math.round(r.bottom + 8);
    var w, left;
    if (vpw <= 767) { w = vpw - 16; left = 8; }
    else { w = Math.min(Math.max(Math.round(r.width), 440), 640, vpw - 16); left = Math.min(Math.max(8, Math.round(r.right - w)), vpw - w - 8); }
    var s = st.panel.style;
    s.top = top + 'px'; s.left = left + 'px'; s.width = w + 'px';
    s.maxHeight = Math.max(160, Math.floor(vh - top - 12)) + 'px';
  }
  function schedulePlace() { if (st.raf) return; st.raf = requestAnimationFrame(function () { st.raf = 0; place(); }); }

  function open() {
    var p = ensurePanel();
    if (p.hidden) {
      p.hidden = false;
      if (!reduced()) { p.classList.add('is-entering'); requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.remove('is-entering'); }); }); }
    }
    place();
    if (st.input) { st.input.setAttribute('aria-expanded', 'true'); st.input.setAttribute('aria-controls', 'nt-ps-panel'); }
  }

  function close() {
    clearTimeout(st.timer);
    if (st.ctrl) { st.ctrl.abort(); st.ctrl = null; }
    st.seq++;
    if (st.panel) { st.panel.hidden = true; st.panel.classList.remove('is-loading'); }
    if (st.input) { st.input.setAttribute('aria-expanded', 'false'); st.input.removeAttribute('aria-activedescendant'); }
    st.active = -1;
  }

  function options() { return st.panel ? qsa('a[role="option"]', st.panel) : []; }

  function setActive(i) {
    var o = options();
    o.forEach(function (a, k) { var on = k === i; a.classList.toggle('is-active', on); a.setAttribute('aria-selected', on ? 'true' : 'false'); });
    st.active = i;
    if (i >= 0 && o[i]) {
      st.input.setAttribute('aria-activedescendant', o[i].id);
      var box = st.scroll, el = o[i];
      var top = el.offsetTop, bottom = top + el.offsetHeight;
      var foot = el.classList.contains('nt-ps__item--all') ? 0 : 56;
      if (top < box.scrollTop) box.scrollTop = Math.max(0, top - 40);
      else if (bottom > box.scrollTop + box.clientHeight - foot) box.scrollTop = bottom - box.clientHeight + foot + 4;
    } else if (st.input) { st.input.removeAttribute('aria-activedescendant'); }
  }

  function afterRender() {
    qsa('a', st.panel).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
    st.active = -1;
    if (st.input) st.input.removeAttribute('aria-activedescendant');
    place();
  }

  /* ---------- états : aide / récents ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function showIdle() {
    ensurePanel();
    var rec = getRecent();
    var h = '';
    if (rec.length) {
      h += '<div class="nt-ps__recent-head"><p class="nt-ps__title" id="nt-ps-t-r">Recherches récentes</p><button type="button" class="nt-ps__clear" data-nt-ps-clear>Effacer</button></div><ul class="nt-ps__sub" role="listbox" id="nt-ps-list" aria-labelledby="nt-ps-t-r">';
      rec.forEach(function (t, i) {
        h += '<li role="presentation"><a class="nt-ps__item nt-ps__item--plain" role="option" aria-selected="false" id="nt-ps-o-' + (i + 1) + '" data-nt-ps-recent="' + esc(t).replace(/"/g, '&quot;') + '" href="/search?q=' + encodeURIComponent(t) + typeParam() + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span class="nt-ps__name">' + esc(t) + '</span></a></li>';
      });
      h += '</ul>';
    }
    h += '<p class="nt-ps__hint">Tapez au moins ' + MIN + ' lettres pour voir des suggestions de produits, de collections et d’articles.</p>';
    st.scroll.innerHTML = h;
    st.status.textContent = '';
    st.lastQ = null;
    open();
    afterRender();
  }
  function typeParam() { return (window.Shopify && Shopify.theme_settings && Shopify.theme_settings.search_option !== 'everything') ? '&type=product' : ''; }

  /* ---------- requête ---------- */
  function url(q) {
    return root().replace(/\/$/, '') + '/search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,article,page,query&resources[limit]=' + limit() +
      '&resources[limit_scope]=each&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=nt-predictive-search';
  }

  function render(html, q) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.nt-ps__inner');
    if (!inner) throw new Error('réponse sans résultats');
    st.scroll.innerHTML = inner.outerHTML;
    var n = parseInt(inner.getAttribute('data-nt-ps-total'), 10) || 0;
    st.status.textContent = n ? n + ' suggestion' + (n > 1 ? 's' : '') + ' disponible' + (n > 1 ? 's' : '') + '. Utilisez les flèches haut et bas.' : 'Aucun résultat';
    st.lastQ = q;
    open();
    afterRender();
  }

  function search(q) {
    if (st.cache[q]) { render(st.cache[q], q); return; }
    if (st.ctrl) st.ctrl.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    st.ctrl = ctrl;
    var seq = ++st.seq;
    clearTimeout(st.loadTimer);
    st.loadTimer = setTimeout(function () { if (seq === st.seq && st.panel && !st.panel.hidden) st.panel.classList.add('is-loading'); }, 220);
    if (st.panel && st.panel.hidden) { /* rien affiché tant qu'il n'y a pas de réponse */ }
    fetch(url(q), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (seq !== st.seq) return;
        clearTimeout(st.loadTimer);
        st.cache[q] = html;
        if (st.panel) st.panel.classList.remove('is-loading');
        if (st.input && st.input.value.trim() === q) render(html, q);
      })
      .catch(function (e) {
        clearTimeout(st.loadTimer);
        if (e && e.name === 'AbortError') return;
        if (seq !== st.seq) return;
        /* échec réseau ou limite de débit : le panneau se ferme, la recherche classique reste disponible */
        close();
      });
  }

  function onInput() {
    var v = st.input.value.trim();
    clearTimeout(st.timer);
    if (v.length < MIN) { st.seq++; if (st.ctrl) st.ctrl.abort(); showIdle(); return; }
    if (v === st.lastQ && st.panel && !st.panel.hidden) return;
    st.timer = setTimeout(function () { search(v); }, DELAY);
  }

  function attach(input) {
    if (st.input && st.input !== input) { st.input.setAttribute('aria-expanded', 'false'); st.input.removeAttribute('aria-activedescendant'); close(); }
    st.input = input;
    st.form = closest(input, 'form');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('autocomplete', 'off');
    if (!input.getAttribute('aria-label') && !input.id) input.setAttribute('aria-label', 'Rechercher');
  }

  function matchInput(t) {
    if (!t || t.nodeType !== 1 || t.tagName !== 'INPUT' || t.name !== 'q') return null;
    if (!enabled()) return null;
    return closest(t, FORMS) ? t : null;
  }

  /* ---------- écouteurs ---------- */
  document.addEventListener('focusin', function (e) {
    var i = matchInput(e.target);
    if (!i) return;
    attach(i);
    var v = i.value.trim();
    if (v.length >= MIN && st.cache[v]) render(st.cache[v], v);
    else if (v.length < MIN) showIdle();
    else search(v);
  });

  document.addEventListener('input', function (e) {
    var i = matchInput(e.target);
    if (!i) return;
    if (st.input !== i) attach(i);
    onInput();
  });

  document.addEventListener('keydown', function (e) {
    var i = matchInput(e.target);
    if (!i || i !== st.input || !st.panel || st.panel.hidden) return;
    var o = options(), n = o.length;
    var k = e.key;
    if (k === 'ArrowDown') { e.preventDefault(); if (n) setActive(st.active + 1 >= n ? 0 : st.active + 1); }
    else if (k === 'ArrowUp') { e.preventDefault(); if (n) setActive(st.active <= 0 ? n - 1 : st.active - 1); }
    else if (k === 'Home' && n && st.active >= 0) { e.preventDefault(); setActive(0); }
    else if (k === 'End' && n && st.active >= 0) { e.preventDefault(); setActive(n - 1); }
    else if (k === 'Enter') {
      if (st.active >= 0 && o[st.active]) {
        e.preventDefault();
        var a = o[st.active];
        var t = a.getAttribute('data-nt-ps-query') || a.getAttribute('data-nt-ps-recent') || st.input.value;
        if (a.hasAttribute('data-nt-ps-query') || a.hasAttribute('data-nt-ps-recent') || a.classList.contains('nt-ps__item--all')) addRecent(t);
        window.location.href = a.href;
      } else { addRecent(st.input.value); }
    }
    else if (k === 'Escape' || k === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (k === 'Tab') { close(); }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = closest(e.target, FORMS);
    if (!f || !enabled()) return;
    var i = f.querySelector('input[name="q"]');
    if (i) addRecent(i.value);
    close();
  }, true);

  document.addEventListener('mousedown', function (e) {
    if (!st.panel || st.panel.hidden) return;
    if (st.panel.contains(e.target)) return;
    if (st.input && (e.target === st.input || (st.form && st.form.contains(e.target)))) return;
    close();
  }, true);

  document.addEventListener('focusout', function (e) {
    if (!st.input || e.target !== st.input) return;
    var to = e.relatedTarget;
    if (to && st.panel && st.panel.contains(to)) return;
    setTimeout(function () { if (document.activeElement !== st.input) close(); }, 120);
  });

  window.addEventListener('resize', schedulePlace);
  window.addEventListener('scroll', schedulePlace, { passive: true, capture: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedulePlace);
  window.addEventListener('pagehide', close);
  if (window.InstantClick && InstantClick.on) InstantClick.on('change', function () { st.panel = null; st.input = null; st.form = null; });
})();
